function picker(err) {
  const msg = typeof err === 'string'
    ? err
    : (err.msg || err.message || err.errMsg || `网络错误${err.status ? `(${err.status})` : '网络错误'}`);
  return msg;
}

function show(err) {
  console.log(err);
  const msg = picker(err);
  window.alert(msg);
}

export default {
  picker,
  show,
};
